import React from 'react'

function TenderTextLinear() {
    return (
        <embed src="\pdfs\EAT1.2.2_WL_Linear_whirl_outlet_kr.pdf" width="100%" height="2100px" />
    )
}

export default TenderTextLinear